import { render, staticRenderFns } from "./collectionDetail.vue?vue&type=template&id=ded7de00&scoped=true"
import script from "./collectionDetail.vue?vue&type=script&lang=js"
export * from "./collectionDetail.vue?vue&type=script&lang=js"
import style0 from "./collectionDetail.vue?vue&type=style&index=0&id=ded7de00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded7de00",
  null
  
)

export default component.exports